import { MimaButton, MimaInput } from '../../components';
import styles from '../../assets/styles/Login/Login.module.scss';
import { Formik } from 'formik';
import React from 'react';

const LoginForm = ({
	validationSchema,
	onSubmit,
	loading,
	owner,
	selectOwnerAccount,
	selectEmployeeAccount,
}) => {
	return (
		<Formik
			initialValues={{
				email: '',
				accountType: 'Business',
				password: '',
			}}
			validationSchema={validationSchema()}
			onSubmit={onSubmit}>
			{({
				handleChange,
				handleBlur,
				handleSubmit,
				setFieldValue,
				values,
				errors,
				touched,
			}) => (
				<div>
					{/* <MimaText
						variant="small"
						align="center"
						mb={1}
						color="var(--color-primary)"
					>
						Kindly Select your Account type
					</MimaText> */}
					{/* <div className={styles.account}>
						<div
							className={`${
								owner ? styles.account__owner : styles.account__owner_b
							}`}
							onClick={() => {
								selectOwnerAccount();
								setFieldValue('accountType', 'Business');
							}}
						>
							Admin
						</div>
						<div
							className={`${
								owner ? styles.account__employee : styles.account__employee_b
							}`}
							onClick={() => {
								selectEmployeeAccount();
								setFieldValue('accountType', 'Employee');
							}}
						>
							Employee
						</div>
					</div> */}
					<div className={styles.account__desc}>
						You are currently logging in as an{' '}
						<span>{owner ? 'Admin' : 'Employee'}</span>
					</div>
					<MimaInput
						labelTitle="Email address"
						type="text"
						placeholder="Enter your email address"
						id="email"
						name="email"
						value={values.email}
						onChange={handleChange('email')}
						onBlur={handleBlur('email')}
						error={errors.email}
						touched={touched.email}
					/>
					<MimaInput
						labelTitle="Password"
						type="text"
						placeholder="Enter your password"
						id="password"
						name="password"
						value={values.password}
						onChange={handleChange('password')}
						onBlur={handleBlur('password')}
						passwordIcon
						error={errors.password}
						touched={touched.password}
					/>
					<MimaButton
						title="Login"
						onClick={handleSubmit}
						type="submit"
						loading={loading}
						variant="form"
					/>
				</div>
			)}
		</Formik>
	);
};

export default LoginForm;
